import { TableRow, TableCell, Checkbox, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { KmsVehicle } from '../store/slices/timesheet/timesheetPageSlice'
import CustomTextField from './general/CustomTextField/CustomTextField'

interface KmsVehicleRowProps {
	kmv: KmsVehicle
	idx: number
	kmsVehicles: KmsVehicle[]
	isSecondaryDriverService: boolean
	removeKmsVehicleHandler: (kmsId: number | undefined) => void
	onKmsIniChange: (idx: number, value: number) => void
	onKmsEndChange: (idx: number, value: number) => void
	onInEmptyChange: (idx: number, value: boolean) => void
}

function KmsVehicleRow({
	kmv,
	idx,
	kmsVehicles,
	isSecondaryDriverService,
	removeKmsVehicleHandler,
	onKmsIniChange,
	onKmsEndChange,
	onInEmptyChange,
}: Readonly<KmsVehicleRowProps>): JSX.Element {
	return (
		<TableRow>
			<TableCell
				sx={{
					fontFamily: 'Poppins, sans-serif',
					fontSize: '0.75rem',
					fontWeight: 400,
					lineHeight: '130%',
					border: 'none',
					color: 'var(--primary-dark)',
				}}
			>
				Registo {idx + 1}
			</TableCell>
			<TableCell
				sx={{
					fontFamily: 'Poppins, sans-serif',
					fontSize: '0.75rem',
					fontWeight: 400,
					lineHeight: '130%',
					border: 'none',
				}}
			>
				<CustomTextField
					aria-label={`Kms start do registo ${idx + 1}`}
					size='small'
					type='number'
					disabled={isSecondaryDriverService}
					value={kmv.kmsIni}
					onChange={e => {
						const val = Number(e.target.value)
						if (!isNaN(val)) onKmsIniChange(idx, val)
					}}
				/>
			</TableCell>
			<TableCell
				sx={{
					fontFamily: 'Poppins, sans-serif',
					fontSize: '0.75rem',
					fontWeight: 400,
					lineHeight: '130%',
					border: 'none',
				}}
			>
				<CustomTextField
					aria-label={`Kms end do registo ${idx + 1}`}
					size='small'
					type='number'
					value={kmv.kmsEnd}
					disabled={isSecondaryDriverService}
					onChange={e => {
						const val = Number(e.target.value)
						if (!isNaN(val)) onKmsEndChange(idx, val)
					}}
				/>
			</TableCell>
			<TableCell sx={{ border: 'none' }}>
				<Checkbox
					aria-label={`Registo ${idx + 1} em vazio`}
					size='small'
					disabled={isSecondaryDriverService}
					checked={kmv.inEmpty}
					onChange={() => onInEmptyChange(idx, !kmv.inEmpty)}
					sx={{ color: 'var(--primary-light)', '&.Mui-checked': { color: 'var(--primary)' } }}
				/>
			</TableCell>
			<TableCell
				align='right'
				sx={{ border: 'none' }}
			>
				{kmsVehicles.length > 1 && kmsVehicles.length === idx + 1 && (
					<IconButton
						aria-label='remove kms vehicle'
						size='small'
						sx={{
							width: '20px',
							height: '20px',
						}}
						onClick={() => removeKmsVehicleHandler(kmv.kmsId)}
					>
						<DeleteIcon sx={{ color: 'var(--primary)' }} />
					</IconButton>
				)}
			</TableCell>
		</TableRow>
	)
}

export default KmsVehicleRow
